import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.palette.secondary[50],
            border: `1px solid ${theme.palette.secondary[200]}`,
            borderRadius: theme.spacing(0.5),
        },
        header: {
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            borderBottom: `1px solid ${theme.palette.secondary[200]}`,
        },
        formContainer: {
            flex: 1,
            padding: theme.spacing(2),
            overflow: 'auto',
        },
    }
})

export default useStyles
